import trapFocus from '../utils/trapFocus';
import { SETTINGS } from '../utils/constants';

const CLOSE_SELECTOR = '[data-close-product-content-drawer]';
const OPEN_SELECTOR = '[data-product-content-drawer-open]';
const DRAWER_SELECTOR = '[data-product-content-drawer]';
const VISIBLE_CLASS = 'is-visible';

const mountDrawersToBody = scope => {
  scope.querySelectorAll(DRAWER_SELECTOR).forEach(dialog => {
    if (dialog.parentElement !== document.body) {
      document.body.appendChild(dialog);
    }
  });
};

const closeProductContentDrawer = (dialog, trigger) => {
  if (!dialog) return;
  dialog.classList.remove(VISIBLE_CLASS);
  window.setTimeout(() => {
    if (dialog.open) {
      dialog.close();
    }
    trigger?.focus();
  }, SETTINGS.FILTER_DRAW_ANIMATION_TIME);
};

const openProductContentDrawer = (dialog, trigger) => {
  if (!dialog || dialog.open) return;

  const handleBackdropClick = event => {
    const isInDialog = event.clientX >= dialog.getBoundingClientRect().left;
    if (!isInDialog) {
      closeProductContentDrawer(dialog, trigger);
    }
  };

  const handleCloseClick = () => {
    closeProductContentDrawer(dialog, trigger);
  };

  const handleKeydown = event => {
    if (event.key === 'Escape') {
      closeProductContentDrawer(dialog, trigger);
    }
  };

  dialog.showModal();
  requestAnimationFrame(() => {
    dialog.classList.add(VISIBLE_CLASS);
  });
  trapFocus(dialog);

  dialog.addEventListener('click', handleBackdropClick);
  dialog.querySelectorAll(CLOSE_SELECTOR).forEach(btn => {
    btn.addEventListener('click', handleCloseClick);
  });
  document.addEventListener('keydown', handleKeydown);

  dialog.addEventListener(
    'close',
    () => {
      dialog.classList.remove(VISIBLE_CLASS);
      dialog.removeEventListener('click', handleBackdropClick);
      dialog.querySelectorAll(CLOSE_SELECTOR).forEach(btn => {
        btn.removeEventListener('click', handleCloseClick);
      });
      document.removeEventListener('keydown', handleKeydown);
    },
    { once: true }
  );

  document.dispatchEvent(
    new CustomEvent('product-content-drawer:open', { detail: { drawerId: dialog.dataset.productContentDrawer } })
  );
};

const initProductContentDrawers = (scope = document) => {
  const root = scope.querySelector('[data-product-content-drawers]');
  if (!root || root.dataset.productContentDrawersInit === 'true') return;

  mountDrawersToBody(scope);
  root.dataset.productContentDrawersInit = 'true';

  root.querySelectorAll(OPEN_SELECTOR).forEach(trigger => {
    trigger.addEventListener('click', () => {
      const drawerId = trigger.getAttribute('data-product-content-drawer-open');
      if (!drawerId) return;
      const dialog = document.querySelector(`${DRAWER_SELECTOR}[data-product-content-drawer="${drawerId}"]`);
      openProductContentDrawer(dialog, trigger);
    });
  });
};

export { closeProductContentDrawer };

export default initProductContentDrawers;
